import React from "react";

import logo from "assets/images/logo-white.svg";

const Logo = () => (
  <div className="mx-2xl mt-2xl mb-md h-xl hidden lg:block">
    <img src={logo} alt="Tester Work logo" />
  </div>
);

export default Logo;
